import React from 'react';

// von: https://github.com/yondepo/react-event-outside

export default (events = ['click']) =>
  (Target) =>
    class ReactEventOutside extends React.Component {
      constructor(props) {
        super(props);
        this.handleEvent = this.handleEvent.bind(this);
      }

      componentDidMount() {
        events.forEach((event) =>
          this.wrap.addEventListener(event, this.handleEvent, true),
        );
      }

      componentWillUnmount() {
        events.forEach((event) =>
          this.wrap.removeEventListener(event, this.handleEvent, true),
        );
      }

      handleEvent(e) {
        if (typeof this.target.handleEvent === 'function') {
          this.target.handleEvent(e, this.wrap);
        }
      }

      render() {
        return (
          <div
            ref={(node) => {
              this.wrap = node;
            }}
          >
            <Target
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...this.props}
              ref={(node) => {
                this.target = node;
              }}
            />
          </div>
        );
      }
    };
